/*
 *
 * RootModal
 *
 */

import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { selectModalType, selectModalProps } from './selectors';
import { clearModal } from './actions';
import {
  COLOR_PICKER,
  PLAN_SELECTION,
  INTUITIVE_MODAL,
  UPGRADE_TO_ENTERPRISE_MODAL,
  LAPSED_MODAL,
  RESUBSCRIBE_MODAL
} from "./constants";

import ColorPickerModal from 'components/ColorPickerModal';
import PlanSelectionModal from 'components/PlanSelectionModal';
import ResubscribeModal from 'components/ResubscribeModal';
import LapsedModal from 'components/LapsedModal';
import IntuitiveModal from 'components/IntuitiveModal';
import UpgradeToEnterpriseModal from 'components/UpgradeToEnterpriseModal';

const MODAL_COMPONENTS = {
  [COLOR_PICKER]: ColorPickerModal,
  [PLAN_SELECTION]: PlanSelectionModal,
  [INTUITIVE_MODAL]: IntuitiveModal,
  [UPGRADE_TO_ENTERPRISE_MODAL]: UpgradeToEnterpriseModal,
  [LAPSED_MODAL]: LapsedModal,
  [RESUBSCRIBE_MODAL]: ResubscribeModal,
};

export const RootModal = ({ modalType, modalProps, close }) => {
  if(!!modalType) {
    const SpecificModal = MODAL_COMPONENTS[modalType];
    return (<SpecificModal modalProps={modalProps} close={close} />);
  } else {
    return (<div />);
  }
};

const mapStateToProps = createStructuredSelector({
  modalType: selectModalType(),
  modalProps: selectModalProps(),
});

const mapDispatchToProps = (dispatch) => ({
  close: () => dispatch(clearModal()),
});

export default connect(mapStateToProps, mapDispatchToProps)(RootModal);
